import React from 'react';
import './CardComponent.css'; // Import your CSS file

const CardComponent = ({ color, icon, title, value, unit, percentage }) => {
  const cardStyle = {
    background: color,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px',
    padding: '10px',
    color: 'white',
    width:'100%'
  };

  const overlayStyle = {
    position: 'absolute',
    bottom: '-20px',
    right: '-20px',
    width: '150px',
    height: '150px',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '50%',
  };

  const overlayStyle2 = {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    width: '100px',
    height: '100px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '50%',
  };

  return (
    <div className="card" style={cardStyle}>
      <div style={overlayStyle}></div>
      <div style={overlayStyle2}></div>
      <div className="card-header">
        <span className="card-title">{title}</span>
        {icon && <span className="card-icon">{icon}</span>}
      </div>
      <div className="card-value">
        {value}
        <span className="card-unit">{unit}</span>
      </div>

      {percentage &&
        <div className="card-progress">
          <div className="card-progress-bar" style={{ width: `${percentage}%` }}></div>
        </div>
      }
      {percentage &&
        <div className="card-percentage">{percentage}%</div>
      }
    </div>
  );
};

export default CardComponent;